import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RFCsService } from '../utils/services/rfcs.service';
import { UtilsService } from '../utils/services/utils.service';
import { CheckoutService } from '../utils/services/checkout.service';
import { ResumenData } from '../../../../../core/model/DataCart';
import { ProductData } from '../../../../../core/model/Product.model';
import { LoginService } from '../../../../../services/login/login.service';
import { CartService } from '../../../../../services/generar-pedido/cart/cart.service';
import { EmpresaService } from '../../../../../services/Empresa/Empresa.service';

@Component({
  selector: 'app-pedido-generado',
  templateUrl: './pedido-generado.component.html',
  styleUrls: ['./pedido-generado.component.scss']
})
export class PedidoGeneradoComponent implements OnInit {
  public dataParams$: Observable<Params>;
  public dataProduct: ProductData[];
  public resumen: ResumenData;
  public logo = '"./../../../../assets/logo/logo_blanco.svg';
  public msj = 'Ir al inicio';
  public showButton: boolean;
  public dataPage: any = {};
  empresaId: number = 1;

  constructor(
    private serviceCart: CartService,
    private facturasService: RFCsService,
    private login: LoginService,
    private checkout: CheckoutService,
    private utilService: UtilsService,
    private cartService: CartService,
    private empresaService: EmpresaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.dataPage.pedidoSucursal = Number(this.data.pedidoSucursal) > 0 ? this.data.pedidoSucursal : null;
    this.dataPage.pedidoCedis = Number(this.data.pedidoCedis) > 0 ? this.data.pedidoCedis : null;
    this.dataPage.today = new Date();
    this.dataPage.user = this.login.getDataClientePedido();
    this.dataPage.NombreVendedor = this.login.getNombreVendedor();
    this.dataPage.cartResumen = this.cartService.calcularResumen(null);
    this.serviceCart.guardCheckout = false;
    this.dataProduct = JSON.parse(localStorage.getItem('items-cart-login'));
    this.resumen = JSON.parse(localStorage.getItem('resumen-cart-login'));
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });

    /* console.log("Productos",this.dataProduct)
    console.log("RESUMEN",this.resumen) */
    const facturar = JSON.parse(localStorage.getItem('rfcInovice'));

    if (facturar !== undefined && facturar !== null) {
      this.facturasService.sendMailInvoice(facturar);
      localStorage.removeItem('rfcInovice');
    }
    
    this.cartService.destroyCart();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  public gotoHome = (): void => {
      window.location.reload();
  };

  public getFromLocalStg(key: string) {
    return this.utilService.isJson(localStorage.getItem(key))
      ? JSON.parse(localStorage.getItem(key))
      : localStorage.getItem(key);
  }

  getCFDIData(key) {
    return this.utilService.getCFDIData(key);
  }

  public destroy(): void {
    console.log('destroy');
    localStorage.removeItem('comision-cart-login');
    localStorage.removeItem('resumen-cart-login');
    localStorage.removeItem('envio-cart-login');
    localStorage.removeItem('items-cart-login');
    localStorage.removeItem('address-envio');
    localStorage.removeItem('address-envio-cedis');
    localStorage.removeItem('opcion-metodo-entrega');
    localStorage.removeItem('pasarela-pago');
    localStorage.removeItem('data-pedido');
    localStorage.removeItem('carrito');
    localStorage.removeItem('tipo-pago');
    localStorage.removeItem('tipo-entrega-cedis');
    localStorage.removeItem('tipo-entrega-sucursal');
    localStorage.removeItem('cliente-CFDI'); 
    localStorage.removeItem('data-operation');
    localStorage.removeItem('data-reference');
    localStorage.removeItem('clientePedidoSession')
    this.serviceCart.guardCheckout = false;
    this.serviceCart.goToCart.next(null);
    this.serviceCart.goToCart.complete();
    this.checkout.completeTipoDeCompra$();
    this.checkout.completeMercanciaSucursal$();
    this.checkout.completeEnvioMercanciaCedis$();
    this.checkout.completeLimiteCredito$();
    this.checkout.completeMetodoPago$();
    this.checkout.completeRecalculaResumen$();
    this.checkout.completeformularioCheckout$();
    this.checkout.completeformularioCheckout$();
    console.log('end destroy');
  }
}